import classnames from 'classnames'

import { withTranslate } from 'i18n/utils'

import { pendingSelector } from 'api/selectors'

import {
    selectedVehicleSelector,
    selectedBookingItemSelector,
    promoCodeBarcodeSelector,
    rawPromoCodeSelector,
} from 'booking/selectors'
import { redeemPromoCode, removePromoCode, setRawPromoCode } from 'booking/actions'
import { selectVehicle } from 'booking/actions'
import usePromoCodeData from 'shared/hooks/usePromoCodeData'

import PromoCode from '@components/PromoCode'

import bookingStyles from '../styles.module.scss'

const PromoCodeSection = ({ promoCodeBtnDisabled, currentItemIndex, rate }) => {
    const {
        rawPromoCode,
        setRawPromoCode,
        removePromoCode,
        onAddPromoCode,
        promoCodeError,
        successPromoCode,
        isPromoCodeLoading,
    } = usePromoCodeData({ currentItemIndex, rate })

    return (
        <div className={classnames('d-inline-flex mt-4 p-0', bookingStyles.promoCodeContainer)}>
            <PromoCode
                promoCodeValue={rawPromoCode}
                setRawPromoCode={setRawPromoCode}
                onRemovePromoCode={removePromoCode}
                onAddPromoCode={onAddPromoCode}
                removePromoCodeLabel={<T>booking.promocode.remove</T>}
                btnLabel={<T>booking.promocode.apply</T>}
                placeholder={<T>booking.hourly.flow.promocode.placeholder</T>}
                error={promoCodeError}
                success={successPromoCode}
                btnStyle={'primary'}
                label={<T>booking.hourly.flow.promocode.placeholder</T>}
                disabled={isPromoCodeLoading || promoCodeBtnDisabled}
                isLoading={isPromoCodeLoading}
            />
        </div>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            selectedVehicle: selectedVehicleSelector,
            promoCodeBarcode: promoCodeBarcodeSelector,
            rawPromoCode: rawPromoCodeSelector,
            promoCodePending: pendingSelector,
            selectedBookingItem: selectedBookingItemSelector,
        }),
        {
            selectVehicle,
            redeemPromoCode,
            setRawPromoCode,
            removePromoCode,
        }
    )
)(PromoCodeSection)
